export default {
  enabled: true,
  textEncoding: "auto",
  forced: false,
  burningEnabled: false,
  cea608Enabled: false,
  cea608Mode: "singleCode",
};
